import { render, staticRenderFns } from "./CurrencyGroup.vue?vue&type=template&id=08c84854"
import script from "./CurrencyGroup.vue?vue&type=script&lang=js"
export * from "./CurrencyGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports